module.exports = __webpack_public_path__ + "static/media/34DSS6.f13444bc.jpg";